import { createStore } from 'vuex'
import dealer from './dealer'

const state = () => ({
  initialized: false,
  errors: [],
  location: '',
  latitude: '',
  longitude: ''
})

const getters = {}

const mutations = {
  setInitialized (state, payload) {
    state.initialized = payload
  },
  setErrors (state, payload) {
    state.errors.push(payload)
  },
  setLocation (state, payload) {
    state.location = payload
  },
  setLatitude (state, payload) {
    state.latitude = payload
  },
  setLongitude (state, payload) {
    state.longitude = payload
  }
}

const actions = {
  init ({ dispatch, commit }) {
    Promise.all([
      dispatch('dealer/get')
    ]).then(() => {
      commit('setInitialized', true)
    })
  },
  updateLocation ({ commit }, payload) {
    commit('setLocation', payload.location)
    commit('setLatitude', payload.latitude)
    commit('setLongitude', payload.longitude)
  },
  filter ({ commit, dispatch }) {
    commit('dealer/resetCurrentPage')
    dispatch('pushState')
    Promise.all([
      dispatch('dealer/get')
    ])
  },
  pushState ({ state }) {
    const url = new URL(window.location.href)
    url.searchParams.delete('location-name')
    url.searchParams.delete('lat')
    url.searchParams.delete('lng')
    if (state.location) {
      url.searchParams.set('location-name', state.location)
    }
    if (state.latitude && state.longitude) {
      url.searchParams.set('lat', state.latitude)
      url.searchParams.set('lng', state.longitude)
    }
    window.history.pushState({}, '', url)
  },
  loadMore ({ commit, dispatch }) {
    commit('dealer/increaseCurrentPage')
    Promise.all([
      dispatch('dealer/get')
    ])
  }
}

const modules = {
  dealer: dealer
}

export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules
})
